import socketService from '../socketService';
import { logout as logoutAction } from '../../redux/authSlice';
import oidcAuth from './oidc-client';

type Dispatch = (action: ReturnType<typeof logoutAction>) => unknown;

export async function logoutAuthenticatedSession(dispatch: Dispatch): Promise<void> {
  try {
    socketService.disconnect();
  } catch {
    // A socket shutdown failure must not prevent authentication from ending.
  }

  try {
    dispatch(logoutAction());
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('auth_token');
    await oidcAuth.logout();
  } catch {
    dispatch(logoutAction());
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('auth_token');
    sessionStorage.setItem('logout_in_progress', 'true');
    window.location.href = '/login';
  }
}
